import React, { useState } from 'react';
import Chart from 'react-apexcharts';

const BarChartComponent = ({ height = "350px", title = "Son 3 Gün Servisleri" }) => {
  const [data] = useState([
    { name: "Servis 1", value: 20 },
    { name: "Servis 2", value: 40 },
    { name: "Servis 3", value: 60 }
  ]);

  const getLastThreeDays = () => {
    const today = new Date();
    return [...Array(3)].map((_, i) => {
      const d = new Date();
      d.setDate(today.getDate() - (2 - i)); 
      return d.toLocaleDateString("tr-TR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric"
      });
    });
  };

  const categories = getLastThreeDays();

  const series = [{ name: "Servisler", data: data.map(item => item.value) }];

  const options = {
    chart: { type: 'bar', toolbar: { show: false } },
    plotOptions: {
      bar: { horizontal: false, columnWidth: '20%', borderRadius: 10, borderRadiusApplication: 'end' }
    },
    colors: ['#33AD5C'],
    xaxis: { categories },
    dataLabels: { enabled: false },
    stroke: { show: true, width: 3, colors: ['transparent'] },
    yaxis: {
      min: 0, max: 100, tickAmount: 5,
      labels: { style: { colors: '#6c757d', fontSize: '12px' } }
    },
    fill: { opacity: 1 },
    tooltip: { y: { formatter: val => val } }
  };

  return (
    <div className="card p-3 shadow-sm" style={{ height }}> 
      <h4 style={{fontSize:16, marginBottom:6}}>{title}</h4>
      <Chart options={options} series={series} type="bar" height="100%" /> 
    </div>
  );
};

export default BarChartComponent;
